import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SkipForward2Icon = React.forwardRef(function SkipForward2Icon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7C8.13228 7 5 10.1323 5 14C5 17.8677 8.13228 21 12 21C15.8677 21 19 17.8677 19 14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14C21 18.9723 16.9723 23 12 23C7.02772 23 3 18.9723 3 14C3 9.02772 7.02772 5 12 5H15C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H12Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2929 1.29289C10.6834 0.902369 11.3166 0.902369 11.7071 1.29289L16.4142 6L11.7071 10.7071C11.3166 11.0976 10.6834 11.0976 10.2929 10.7071C9.90237 10.3166 9.90237 9.68342 10.2929 9.29289L13.5858 6L10.2929 2.70711C9.90237 2.31658 9.90237 1.68342 10.2929 1.29289Z"
      ></path>
    </svg>
  )
})

SkipForward2Icon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SkipForward2Icon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SkipForward2Icon
